/* eslint-disable prettier/prettier */
<template>
    <section class="services" id="services">
        <div class="services-wrapper">
            <h1>Our Services</h1>
            <div class="services-content">
                <div class="faqs">
                    <div class="faq-column">
						<!-- <faq>
							Test
						</faq> -->
                        <Faq
                            v-for="(service, index) in cue_left"
                            :key="index"
                            :body="service.body"
                            :title="service.title"
                        />
                    </div>
                    <div class="faq-column">
                        <Faq
                            v-for="(service, index) in cue_right"
                            :key="index"
                            :body="service.body"
                            :title="service.title"
                        />
                    </div>
                </div>
            </div>
        </div>
        <!--end.services-wrapper-->
    </section>
    <!--end.section-->
</template>

<script>
import Faq from "@/components/Faq";

export default {
    components: {
        Faq
    },

    data() {
        return {
            cue_left: [
                {
                    title:
                        "Enterprise Business Applications Consulting & Implementation",
                    body:
                        "We offer end-to-end application management for Oracle. As a Silver Oracle partner we provide full Oracle E-Business Suite implementations, training and support services. This includes: <ul><li>Financials</li><li>Supply Chain Management</li><li>Human Capital Management</li><li>Projects Suite</li><li>Database Management Services</li></ul>"
                },
                {
                    title: "Project Management & Business Analysis",
                    body:
                        "We provide Project Managers and Business Analysts to guide and coordinate requirements and tasks from start to finish."
                },
                {
                    title: "Software Development",
                    body:
                        "We develop custom solutions to solve your business challenges. Our solutions are cross-platform and we offer high levels code security and quality using test driven development techniques. We also specialise in developing Native Mobile solutions using <strong>Xamarin</strong>. Our development methodology is a hybrid model between waterfall and agile."
                },
                {
                    title:
                        "Managed IT Services",
                    body:
                        "We will help you reduce IT operational costs, while improving your end user experience by managing your application portfolio in support of your business goals."
                }
            ],
            cue_right: [
                {
                    title:
                        "Information Security",
                    body:"We assist you identify devices in your network, how they’ve connected and their operating systems, Enforce your accurate policies, protect your resources and provide real threat remediation."
                },
                {
                    title:"IT Infrastructure",
                    body:"<ul><li>Hardware Procurement</li><li>PaaS</li><li>System Integration Services</li></ul>"
				},
                {
                    title:
                        "Business Intelligence & Data Analytics",
                    body:
                        "We will employ the broader insights of data science to find actionable data and help future proof your business."
                }
            ]
        };
    }
};
</script>
